export const mappingOverviewComponentTable = [
  {
    _config: {
      type: "checkbox",
      displayInColumn: true,
    },
    display_name: "",
    key: "row-select",
    headerStyles: {
      background: "#7593F2",
      color: "#000000",
      width: "5%",
      "font-size": "11px",
      "font-weight": 600,
    },
  },
  {
    display_name: "File Name",
    key: "file_name",
    headerStyles: {
      background: "#7593F2",
      color: "#000000",
      "font-size": "11px",
      "font-weight": 600,
    },
  },
  {
    display_name: "User Story",
    key: "user_story",
    headerStyles: {
      background: "#7593F2",
      color: "#000000",
      "font-size": "11px",
      "font-weight": 600,
    },
  },
  {
    display_name: "Test Case",
    key: "test_case",
    headerStyles: {
      background: "#7593F2",
      color: "#000000",
      "font-size": "11px",
      "font-weight": 600,
    },
  },
  {
    display_name: "Methods",
    key: "methods",
    headerStyles: {
      background: "#7593F2",
      color: "#000000",
      "font-weight": 600,
      "font-size": "11px",
    },
  },
  {
    display_name: "Expand",
    key: "open_modal",
    headerStyles: {
      background: "#7593F2",
      color: "#000000",
      "font-size": "11px",
      "font-weight": 600,
    },
    _config: {
      type: "icon",
      value: "open_in_new",
      isClickable: "true",
      displayInColumn: false,
    },
  },
];
